var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Like component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLike extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5714 8.47619H14.3272V4.38095C14.3272 3.71429 14.0476 3.04762 13.5816 2.66667C13.1157 2.19048 12.4633 2 11.8109 2C10.9721 2 10.1333 2.47619 9.76055 3.14286L5.84626 9.42857H2.49116C1.65238 9.42857 1 10.0952 1 10.9524V19.5238C1 20.381 1.65238 21.0476 2.49116 21.0476H6.03266L7.05783 21.619C7.61701 21.9048 8.17619 22 8.73538 22H19.1735C20.4782 22 21.5034 21.0476 21.6898 19.8095C21.6898 19.8095 22.9946 11.2381 22.9946 11.1429C23.0878 9.71429 21.9694 8.57143 20.5714 8.47619ZM2.39796 19.5238V10.9524C2.39796 10.8571 2.39796 10.8571 2.49116 10.8571H5.56667V19.619H2.49116C2.39796 19.619 2.39796 19.619 2.39796 19.5238ZM20.2918 19.619C20.1986 20.1905 19.7327 20.5714 19.1735 20.5714H8.82858C8.45579 20.5714 8.083 20.4762 7.71021 20.2857L6.96463 19.9048V10.381L10.8789 4C11.0653 3.71429 11.4381 3.52381 11.8109 3.52381C12.0905 3.52381 12.3701 3.61905 12.5565 3.80952C12.7429 4 12.9293 4.28571 12.9293 4.57143V9.2381C12.9293 9.61905 13.2088 10 13.6748 10H20.5714C21.2238 10 21.6898 10.5714 21.6898 11.1429C21.5966 11.1429 20.2918 19.619 20.2918 19.619Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLike.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLike.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLike.prototype, "size", void 0);
if (customElements.get('cat-icon-like') === undefined) {
    customElements.define('cat-icon-like', BlocksIconLike);
}
